import { DashboardEffect } from "@app/store/dashboard/effects/dashboard.effect";

export const appEffects = [
    DashboardEffect,
]
